import utils from '@/services/utils';

export default {
  getIndexInfo(variables = {}) {
    return utils.get('/api/home/student/user/get/homePageList', variables);
  },
  setTarget(variables) {
    return utils.post('/api/home/student/user/update/targetSet', variables);
  },
};
